import { styled } from '@mui/material/styles';
import { IconButton } from 'components/ui/IconButton';
import type { PrimaryNavigationMenuItemProps } from 'components/ui/PrimaryNavigation';
import { getThemeSpacingCssPx } from 'components/ui/utilities/theme';
import { getCssPx } from 'components/ui/utilities/zoom';

interface FileRowActionButtonStyleProps {
  actionTone?: PrimaryNavigationMenuItemProps['tone'];
}

const shouldForwardActionButtonProp = (prop: PropertyKey) => prop !== 'actionTone';

export const FileRowActionsRoot = styled('div')(({ theme }) => ({
  '--icon-button-compact-icon-size': getCssPx(16),
  '--icon-button-compact-size': getCssPx(20),
  '--icon-button-radius': getCssPx(theme.shape.radius.xs),
  '--file-row-actions-spacing-xs': getThemeSpacingCssPx(theme, 'xs'),
  alignItems: 'center',
  display: 'inline-flex',
  flex: '0 0 auto',
  gap: 'var(--file-row-actions-spacing-xs)',
  minWidth: 0,
  opacity: 0,
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shortest,
  }),
  '& [data-file-row-actions-menu-trigger="true"]': {
    display: 'none',
  },
  '@container (max-width: 520px)': {
    '& [data-file-row-actions-inline="true"]': {
      display: 'none',
    },
    '& [data-file-row-actions-menu-trigger="true"]': {
      display: 'inline-flex',
    },
  },
}));

export const FileRowActionsInlineGroup = styled('span')({
  alignItems: 'center',
  display: 'inline-flex',
  gap: 'var(--file-row-actions-spacing-xs)',
});

export const FileRowActionButton = styled(IconButton, {
  shouldForwardProp: shouldForwardActionButtonProp,
})<FileRowActionButtonStyleProps>(({ actionTone, theme }) => ({
  ...(actionTone === 'danger' ? {
    color: theme.palette.red[600],
    '&:hover, &:focus-visible, &[aria-pressed="true"]': {
      backgroundColor: theme.palette.red[100],
      color: theme.palette.red[700],
    },
    '&.Mui-disabled': {
      color: theme.palette.red[300],
      opacity: 0.6,
    },
  } : {}),
  '&:focus-visible': {
    boxShadow: `0 0 0 1px ${theme.palette.brand[400]}`,
    outline: 0,
  },
}));
